/**
 * @flow
 * @relayHash 954bc94f2675176cb34cd2536f89262c
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type MainAppBootstrapperKeepaliveQueryVariables = {||};
export type MainAppBootstrapperKeepaliveQueryResponse = {|
  +viewer: ?{|
    +id: string
  |}
|};
export type MainAppBootstrapperKeepaliveQuery = {|
  variables: MainAppBootstrapperKeepaliveQueryVariables,
  response: MainAppBootstrapperKeepaliveQueryResponse,
|};
*/


/*
query MainAppBootstrapperKeepaliveQuery {
  viewer {
    id
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "viewer",
    "storageKey": null,
    "args": null,
    "concreteType": "User",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "id",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "MainAppBootstrapperKeepaliveQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "MainAppBootstrapperKeepaliveQuery",
    "argumentDefinitions": [],
    "selections": (v0/*: any*/)
  },
  "params": {
    "operationKind": "query",
    "name": "MainAppBootstrapperKeepaliveQuery",
    "id": null,
    "text": "query MainAppBootstrapperKeepaliveQuery {\n  viewer {\n    id\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'eee2404c8b4af1338c31292907960da8';
module.exports = node;
